/* APOCALISSE SOLD OUT - moduli di newsletter, registrazione e contatti: controllo anti-bot semplice + tasto di invio sempre visibile nella newsletter.
   Anti-bot: ferma gli script banali (chi compila anche il campo nascosto, chi invia senza aver mai toccato/cliccato/scritto sulla pagina, chi invia nei primi 2 secondi).
   Non ferma chi invia i dati direttamente al server senza aprire la pagina (per quello serve la doppia conferma email).
   Newsletter: se il tema non mostra il tasto "invia" a destra del campo email, qui viene forzato: piccolo rettangolo bianco-lilla con la stessa curva degli angoli
   del campo, con la freccia viola che scorre un poco al passaggio. */
(function () {
  if (window.__asoGuard) return;
  window.__asoGuard = true;
  var SEL = 'form[action*="/contact"], form[action*="/account"]', t0 = Date.now(), human = false;
  var ARROW = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.4" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M5 12h14M13 5l7 7-7 7"/></svg>';
  var st = document.createElement('style');
  st.textContent = '.aso-nl-send{position:absolute!important;right:.6rem!important;left:auto!important;top:50%!important;transform:translateY(-50%)!important;width:4.2rem!important;height:3.4rem!important;min-width:0!important;padding:0!important;margin:0!important;border:0!important;border-radius:calc(var(--inputs-radius,1rem) - .2rem)!important;background:linear-gradient(135deg,#fff,#f1dcff)!important;color:#ba23ef!important;box-shadow:0 .2rem .8rem rgba(0,0,0,.28)!important;display:flex!important;align-items:center;justify-content:center;opacity:1!important;visibility:visible!important;cursor:pointer;z-index:3;transition:transform .15s ease,box-shadow .15s ease}' +
    '.aso-nl-send:hover{transform:translateY(-50%) scale(1.06)!important;box-shadow:0 .3rem 1.2rem rgba(0,0,0,.35)!important}' +
    '.aso-nl-send svg{width:1.6rem!important;height:1.6rem!important;fill:none!important;stroke:currentColor!important;transition:transform .15s ease}.aso-nl-send:hover svg{transform:translateX(.2rem)}' +
    '.aso-nl-wrap input[type=email]{padding-right:5.8rem!important}';
  document.head.appendChild(st);

  ['pointerdown', 'mousedown', 'touchstart', 'keydown'].forEach(function (ev) {
    document.addEventListener(ev, function (e) { if (e.isTrusted) human = true; }, { capture: true, passive: true });
  });

  function nl(form) {
    var em = form.querySelector('input[type="email"]');
    if (!em || form.__nl || form.querySelector('textarea') || !form.querySelector('input[name="contact[tags]"]')) return;
    form.__nl = 1;
    var wrap = em.closest('.field') || em.parentNode;
    wrap.classList.add('aso-nl-wrap');
    if (getComputedStyle(wrap).position === 'static') wrap.style.position = 'relative';
    var b = form.querySelector('button[type="submit"], button:not([type]), input[type="submit"]');
    if (!b || b.tagName === 'INPUT') {
      b = document.createElement('button');
      b.type = 'submit';
      wrap.appendChild(b);
    } else if (b.parentNode !== wrap) {
      wrap.appendChild(b);
    }
    b.classList.add('aso-nl-send');
    b.setAttribute('aria-label', document.documentElement.lang === 'en' ? 'Subscribe' : 'Iscriviti');
    b.innerHTML = ARROW;
  }

  function trap(form) {
    if (!form || form.__asoTrap || !form.matches || !form.matches(SEL)) return;
    form.__asoTrap = 1;
    var h = document.createElement('input');
    h.type = 'text';
    h.name = 'aso_hp_url';
    h.tabIndex = -1;
    h.autocomplete = 'off';
    h.setAttribute('aria-hidden', 'true');
    h.style.cssText = 'position:absolute;left:-9999px;width:1px;height:1px;opacity:0;pointer-events:none';
    form.appendChild(h);
    nl(form);
  }

  function scan() { [].forEach.call(document.querySelectorAll(SEL), trap); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', scan); else scan();
  window.addEventListener('load', scan);
  document.addEventListener('focusin', function (e) { var f = e.target && e.target.closest ? e.target.closest('form') : null; trap(f); }, true);

  document.addEventListener('submit', function (e) {
    var f = e.target;
    if (!f || !f.matches || !f.matches(SEL)) return;
    var hp = f.querySelector('[name="aso_hp_url"]');
    if ((hp && hp.value) || !human || Date.now() - t0 < 2000) {
      e.preventDefault();
      e.stopImmediatePropagation();
      if (window.console) console.warn('ASO: invio bloccato dal controllo anti-bot');
    }
  }, true);
})();